/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { ComponentDefinitionSubCategory } from '../models/component-definition-sub-category';
import { ComponentDefinitionSubCategoryPartial } from '../models/component-definition-sub-category-partial';
import { ComponentDefinitionSubCategoryWithRelations } from '../models/component-definition-sub-category-with-relations';
import { NewComponentDefinitionSubCategory } from '../models/new-component-definition-sub-category';
import { Count as LoopbackCount } from '../models/loopback/count';

@Injectable({
  providedIn: 'root',
})
export class ComponentDefinitionSubCategoryControllerService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation componentDefinitionSubCategoryControllerCount
   */
  static readonly ComponentDefinitionSubCategoryControllerCountPath = '/component-definition-sub-categories/count';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `count()` instead.
   *
   * This method doesn't expect any request body.
   */
  count$Response(params?: {
    where?: any;
  }): Observable<StrictHttpResponse<LoopbackCount>> {

    const rb = new RequestBuilder(this.rootUrl, ComponentDefinitionSubCategoryControllerService.ComponentDefinitionSubCategoryControllerCountPath, 'get');
    if (params) {
      rb.query('where', params.where, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LoopbackCount>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `count$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  count(params?: {
    where?: any;
  }): Observable<LoopbackCount> {

    return this.count$Response(params).pipe(
      map((r: StrictHttpResponse<LoopbackCount>) => r.body as LoopbackCount)
    );
  }

  /**
   * Path part for operation componentDefinitionSubCategoryControllerFindById
   */
  static readonly ComponentDefinitionSubCategoryControllerFindByIdPath = '/component-definition-sub-categories/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findById()` instead.
   *
   * This method doesn't expect any request body.
   */
  findById$Response(params: {
    id: string;
    filter?: any;
  }): Observable<StrictHttpResponse<ComponentDefinitionSubCategory>> {

    const rb = new RequestBuilder(this.rootUrl, ComponentDefinitionSubCategoryControllerService.ComponentDefinitionSubCategoryControllerFindByIdPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
      rb.query('filter', params.filter, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ComponentDefinitionSubCategory>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `findById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findById(params: {
    id: string;
    filter?: any;
  }): Observable<ComponentDefinitionSubCategory> {

    return this.findById$Response(params).pipe(
      map((r: StrictHttpResponse<ComponentDefinitionSubCategory>) => r.body as ComponentDefinitionSubCategory)
    );
  }

  /**
   * Path part for operation componentDefinitionSubCategoryControllerDeleteById
   */
  static readonly ComponentDefinitionSubCategoryControllerDeleteByIdPath = '/component-definition-sub-categories/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteById()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteById$Response(params: {
    id: string;
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, ComponentDefinitionSubCategoryControllerService.ComponentDefinitionSubCategoryControllerDeleteByIdPath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `deleteById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteById(params: {
    id: string;
  }): Observable<void> {

    return this.deleteById$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation componentDefinitionSubCategoryControllerUpdateById
   */
  static readonly ComponentDefinitionSubCategoryControllerUpdateByIdPath = '/component-definition-sub-categories/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateById()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateById$Response(params: {
    id: string;
    body?: ComponentDefinitionSubCategoryPartial
  }): Observable<StrictHttpResponse<ComponentDefinitionSubCategory>> {

    const rb = new RequestBuilder(this.rootUrl, ComponentDefinitionSubCategoryControllerService.ComponentDefinitionSubCategoryControllerUpdateByIdPath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ComponentDefinitionSubCategory>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `updateById$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateById(params: {
    id: string;
    body?: ComponentDefinitionSubCategoryPartial
  }): Observable<ComponentDefinitionSubCategory> {

    return this.updateById$Response(params).pipe(
      map((r: StrictHttpResponse<ComponentDefinitionSubCategory>) => r.body as ComponentDefinitionSubCategory)
    );
  }

  /**
   * Path part for operation componentDefinitionSubCategoryControllerFind
   */
  static readonly ComponentDefinitionSubCategoryControllerFindPath = '/component-definition-sub-categories';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `find()` instead.
   *
   * This method doesn't expect any request body.
   */
  find$Response(params?: {
    filter?: any;
  }): Observable<StrictHttpResponse<Array<ComponentDefinitionSubCategoryWithRelations>>> {

    const rb = new RequestBuilder(this.rootUrl, ComponentDefinitionSubCategoryControllerService.ComponentDefinitionSubCategoryControllerFindPath, 'get');
    if (params) {
      rb.query('filter', params.filter, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<ComponentDefinitionSubCategoryWithRelations>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `find$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  find(params?: {
    filter?: any;
  }): Observable<Array<ComponentDefinitionSubCategoryWithRelations>> {

    return this.find$Response(params).pipe(
      map((r: StrictHttpResponse<Array<ComponentDefinitionSubCategoryWithRelations>>) => r.body as Array<ComponentDefinitionSubCategoryWithRelations>)
    );
  }

  /**
   * Path part for operation componentDefinitionSubCategoryControllerCreate
   */
  static readonly ComponentDefinitionSubCategoryControllerCreatePath = '/component-definition-sub-categories';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `create()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  create$Response(params?: {
    body?: NewComponentDefinitionSubCategory
  }): Observable<StrictHttpResponse<ComponentDefinitionSubCategory>> {

    const rb = new RequestBuilder(this.rootUrl, ComponentDefinitionSubCategoryControllerService.ComponentDefinitionSubCategoryControllerCreatePath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ComponentDefinitionSubCategory>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `create$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  create(params?: {
    body?: NewComponentDefinitionSubCategory
  }): Observable<ComponentDefinitionSubCategory> {

    return this.create$Response(params).pipe(
      map((r: StrictHttpResponse<ComponentDefinitionSubCategory>) => r.body as ComponentDefinitionSubCategory)
    );
  }

}
